var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('pax-universal-selector',{attrs:{"list":_vm.config,"maxTotalPax":9,"storeListValue":_vm.paxes},on:{"change-pax":paxes => _vm.$emit('change-pax', paxes)}})
}
var staticRenderFns = []

export { render, staticRenderFns }